







import { fixedHtmlData, Macros, MacrosCountInEnum, MacrosOptions, MacrosTypeEnum } from "@/services/posts/postTypes/fixedhtml";
import { Component, Prop, Vue } from "vue-property-decorator";
import moment from "moment";

@Component
export default class MacrosComponent extends Vue {
    @Prop() vsid!: string;
    @Prop() data!: fixedHtmlData[];
    countTimeSpan = "";

    get properties(): fixedHtmlData {
        return this.data.filter((x: fixedHtmlData) => x.id === this.vsid)[0];
    }

    get macros(): Macros {
        const properties = this.properties;
        return {
            type: properties.macros.type,
            countIn: properties.macros.countIn,
            date: properties.macros.date,
            time: properties.macros.time,
            macrosOptions: properties.macros.macrosOptions as MacrosOptions
        };
    }

    get isCountInDays(): boolean {
        return this.macros.countIn === MacrosCountInEnum.days;
    }

    get getSelectedDateAndTime(): moment.Moment {
        const selectedDate = moment(this.macros.date).format("YYYY-MM-DD");
        const mergedDateTime = moment(`${selectedDate} ${this.macros.time}`);
        return moment.utc(mergedDateTime);
    }

    // Lifecycles Hooks
    mounted() {
        this.getDateAndTime();
    }

    // Methods

    getDateAndTime() {
        var calculatedDate = "";
        switch (this.macros.type) {
        case MacrosTypeEnum.countDown:
            calculatedDate = this.countdownInterval();
            break;
        case MacrosTypeEnum.countUp:
            calculatedDate = this.countupInterval();
            break;
        default:
            break;
        }
        if (calculatedDate === "") {
            switch (this.macros.countIn) {
            case MacrosCountInEnum.days:
                calculatedDate = "0";
                break;
            case MacrosCountInEnum.daysWithTime:
                calculatedDate = "00:00:00";
                break;
            default:
                break;
            }
        }
        this.countTimeSpan = calculatedDate;
        setTimeout(() => {
            this.getDateAndTime();
        }, 1000);
    }

    countdownInterval(): string {
        var countDownTimeSpan = "";
        var currentTime = moment().utc();
        var countDownEndDate = this.getSelectedDateAndTime;
        if (countDownEndDate.isSameOrAfter(currentTime)) {
            var duration = moment.duration(countDownEndDate.diff());
            var countDownTime = duration.asMilliseconds();
            var countDownDays = Math.floor(duration.asDays());
            countDownTimeSpan = this.formatCountDateAndTime(countDownTime, countDownDays);
        }
        return countDownTimeSpan;
    }

    countupInterval(): string {
        var timeHasPassed = "";
        var currentTime = moment().utc();
        var countUpStartDate = this.getSelectedDateAndTime;
        if (countUpStartDate.isSameOrBefore(currentTime)) {
            var secondsDiff = currentTime.diff(countUpStartDate, "seconds");
            var countUpTime = moment.duration(secondsDiff, "seconds").asMilliseconds();
            var countUpDays = Math.floor(moment.duration(secondsDiff, "seconds").asDays());
            timeHasPassed = this.formatCountDateAndTime(countUpTime, countUpDays);
        }
        return timeHasPassed;
    }

    formatCountDateAndTime(countTime: any, countDays: any): string {
        var formatedCountDateAndTime = "";
        switch (this.macros.countIn) {
        case MacrosCountInEnum.days:
            formatedCountDateAndTime = String(countDays);
            break;
        case MacrosCountInEnum.daysWithTime:
            formatedCountDateAndTime = String(countDays).padStart(2, "0") + moment.utc(countTime).format(":HH:mm");
            break;
        default:
            break;
        }
        return formatedCountDateAndTime;
    }
}
